import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';

const FailedModal = ({
  isOpen,
  onClose,
  message = 'Something went wrong. Please try again.',
  showButton = true,
}) => {
  const [show, setShow] = useState(false);
  const t = useTranslations('common');

  useEffect(() => {
    if (isOpen) {
      setShow(true);

      const timer = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!show) return null;

  return (
    <div
      className={`modalOverlay fixed ${isOpen ? 'show' : ''}`}
      onClick={() => showButton && onClose()}
    >
      <div className={'modalContent'} onClick={(e) => e.stopPropagation()}>
        <div className={'crossContainer'}>
          <svg className={'crossmark'} viewBox='0 0 52 52'>
            <path
              className={'crossLine crossLine1'}
              d='M16 16 36 36'
              fill='none'
            />
            <path
              className={'crossLine crossLine2'}
              d='M36 16 16 36'
              fill='none'
            />
          </svg>
        </div>
        <p className={'message'}>{message}</p>
        {showButton && (
          <button
            className='rounded bg-[#e74c3c] px-4 py-2 text-white hover:bg-[#e74c3c]/90'
            onClick={onClose}
          >
            {t('Close')}
          </button>
        )}
      </div>
    </div>
  );
};

export default FailedModal;
